<template>
  <div class="section-nav" :class="this.$store.state.menu.mobileMenu">
    <div class="nav-items">
      <div class="back" @click="onBack()">
        <img class="mobile-arrow" src="@/assets/mobile-nav-arrow.svg" />
        <span v-html="this.$store.state.menu.currentSectionTitle"></span>
      </div>
      <router-link
        v-for="(item) in this.$store.state.menu.currentSectionNavigation"
        :key="item.url"
        :to="item.url"
      >
        <div @click="onClick()">
          {{item.title}}
          <img class="mobile-arrow-right" src="@/assets/mobile-nav-arrow.svg" />
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionNav",
  props: {
    navigation: Array
  },
  methods: {
    onBack() {
      this.$store.state.menu.mobileMenu = "show-secondary";
    },
    onClick() {
      this.$store.state.menu.mobileMenu = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.section-nav {
  display: block;
  position: absolute;
  white-space: nowrap;
  background-image: linear-gradient(90deg, #07173a 0%, #030a18 100%);
  top: 0;
  left: 0;
  width: 100%;
  min-height: calc(100vh - 60px);
  padding-top: 96px;
  opacity: 0;
  pointer-events: none;
  &.show-links {
    opacity: 1;
    pointer-events: all;
    z-index: 1;
  }
}
.nav-items {
  position: relative;
  a,
  > div {
    border-bottom: 1px solid #fff;
    display: block;
    height: auto;
    text-align: left;
    padding: 5px 15px;
    text-decoration: none;
    text-transform: uppercase;
    color: #fff;
    font-size: 24px;
    letter-spacing: 0;
    position: relative;
  }
  .back {
    background: rgba(255, 255, 255, 0.25);
    position: relative;
    padding: 10px 15px;
  }
  .mobile-arrow-right {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  .mobile-arrow {
    transform: scaleX(-1);
    margin-right: 8px;
  }
}
</style>